import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantResidenceDurationPage = {
  alert: {
    error: 'applicant-residence-duration-page.form.alert.error',
  },
  footer: {
    root: 'applicant-residence-duration-page.footer.root',
  },
  form: {
    h1: 'applicant-residence-duration-page.form.h1',
    h2: 'applicant-residence-duration-page.form.h2',
    radioGroupRoot: 'applicant-residence-duration-page.form.radio-group-root',
    radioOption1: 'applicant-residence-duration-page.form.radio-option-1',
    radioOption2: 'applicant-residence-duration-page.form.radio-option-2',
    root: 'applicant-residence-duration-page.form.root',
    submitButton: 'applicant-residence-duration-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
